import styled from 'styled-components';

export const Content = styled.div`
  padding: 15px;
  min-height: 50px;
  box-sizing: border-box;
`;

export const TablePlace = styled.div`
  margin: 1rem -1rem -1rem;
  max-height: 400px;
  overflow-y: auto;
  tbody tr:hover {
    background-color: #232e35;
  }
`;

export const TopPlace = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0;
`;
